<template>
    <div class="w-100 m-0 d-flex justify-content-center">
        <div class="container-inputs p-3 m-0">
            <Breadcrumbs :breadcrumbs="breadcrumbs"></Breadcrumbs>
            <h1 class="text-white display-4 fw-normal title">Account</h1>
            <hr/>

            <div class="fade-all position-relative">
                <h4 class="text-white fw-bold">Wachtwoord wijzigen</h4>

                <!-- Huidig wachtwoord -->
                <form id="passwordForm" @submit.prevent="submit">
                    <div class="row row-cols-1 row-cols-md-2 position-relative">
                        <div class="col col">
                            <label for="currentPassword" class="text-white fw-bold mt-2">Huidig wachtwoord</label>
                        </div>
                        <div class="col">
                            <input type="password" id="currentPassword" class="form-control" placeholder="Huidig wachtwoord" :value="currentPassword" @input="(event) => currentPassword = event.target.value">
                        </div>
                    </div>

                    <!-- Nieuw wachtwoord -->
                    <div class="row row-cols-1 row-cols-md-2 position-relative my-3">
                        <div class="col">
                            <label for="newPassword" class="text-white fw-bold mt-2">Nieuw wachtwoord</label>
                        </div>
                        <div class="col">
                            <input type="password" id="newPassword" class="form-control" placeholder="Nieuw wachtwoord" :value="newPassword" @input="(event) => newPassword = event.target.value">
                        </div>
                    </div>

                    <!-- Herhaling nieuw wachtwoord -->
                    <div class="row row-cols-1 row-cols-md-2 position-relative my-3">
                        <div class="col">
                            <label for="newPasswordRepeat" class="text-white fw-bold mt-2">Herhaling nieuw wachtwoord</label>
                        </div>
                        <div class="col">
                            <input type="password" id="newPasswordRepeat" class="form-control" placeholder="Herhaling nieuw wachtwoord" :value="newPasswordRepeat" @input="(event) => newPasswordRepeat = event.target.value">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <button class="btn btn-primary"><i class="fa fa-lock me-1"></i> Wachtwoord wijzigen</button>
                        </div>
                    </div>
                </form>

                <hr/>

                <h4 class="text-white fw-bold">E-mailadres wijzigen</h4>

                <form id="emailForm" @submit.prevent="submitEmail">
                    <div class="row row-cols-1 row-cols-md-2 position-relative">
                        <div class="col col">
                            <label for="currentPassword" class="text-white fw-bold mt-2">Huidig e-mailadres</label>
                        </div>
                        <div class="col">
                            <div class="position-relative text-white mt-2" id="currentEmail"></div>
                        </div>
                    </div>

                    <!-- Nieuw e-mailadres -->
                    <div class="row row-cols-1 row-cols-md-2 position-relative my-3">
                        <div class="col">
                            <label for="newEmailAddress" class="text-white fw-bold mt-2">Nieuw e-mailadres</label>
                        </div>
                        <div class="col">
                            <input type="email" id="newEmailAddress" class="form-control" placeholder="Nieuw e-mailadres" :value="newEmailAddress" @input="(event) => newEmailAddress = event.target.value">
                        </div>
                    </div>

                    <!-- Herhaling nieuw e-mailadres -->
                    <div class="row row-cols-1 row-cols-md-2 position-relative my-3">
                        <div class="col">
                            <label for="newEmailAddressRepeat" class="text-white fw-bold mt-2">Herhaling nieuw e-mailadres</label>
                        </div>
                        <div class="col">
                            <input type="email" id="newEmailAddressRepeat" class="form-control" placeholder="Herhaling nieuw e-mailadres" :value="newEmailAddressRepeat" @input="(event) => newEmailAddressRepeat = event.target.value">
                        </div>
                    </div>

                    <div class="row">
                        <div class="col">
                            <button class="btn btn-primary"><i class="fa fa-lock me-1"></i> E-mailadres wijzigen</button>
                        </div>
                    </div>
                </form>

                <template style="display: none;" id="pushNotificationsTemplate">
                    <hr/>

                    <div class="d-md-flex d-block position-relative mb-2">
                        <h4 class="fw-bold text-white">Pushmeldingen</h4>
                    </div>

                    <div id="pushNotifications" class="mb-3 position-relative">
                        <p class="text-white">Deze pushmeldingen ontvang je in de app van Zelfstandig Ondernemers voor Android en iOS.</p>

                        <div class="form-group mb-3">
                            <div class="form-check form-switch">
                                <input id="allPushNotificationsEnabled" class="form-check-input" type="checkbox" role="switch" v-model="allPushNotificationsEnabled" style="transform: scale(1.2);">
                                <label class="form-check-label text-white" for="allPushNotificationsEnabled">
                                    Alle meldingen
                                </label>
                            </div>
                        </div>

                        <div class="form-group mb-3">
                            <div class="form-check form-switch">
                                <input id="newsPushNotificationsEnabled" class="form-check-input" name="receive_news_push_notifications" type="checkbox" role="switch" v-model="newsPushNotificationsEnabled" style="transform: scale(1.2);">
                                <label class="form-check-label text-white" for="newsPushNotificationsEnabled">
                                    Nieuwsmeldingen
                                </label>
                                <i class="ms-2 fa fa-question-circle text-white notifications-explanation" role="button" style="cursor: pointer;"
                                    data-title="Nieuwsmeldingen"
                                    data-content="Je ontvangt pushmeldingen wanneer er nieuwe nieuwsberichten beschikbaar zijn in de app."></i>
                            </div>
                        </div>

                        <div class="form-group mb-3">
                            <div class="form-check form-switch">
                                <input id="adminPushNotificationsEnabled" class="form-check-input" name="receive_admin_push_notifications" type="checkbox" role="switch" v-model="adminPushNotificationsEnabled" style="transform: scale(1.2);">
                                <label class="form-check-label text-white" for="adminPushNotificationsEnabled">
                                    Administratieve meldingen
                                </label>
                                <i class="ms-2 fa fa-question-circle text-white notifications-explanation" role="button" style="cursor: pointer;"
                                    data-title="Administratieve meldingen"
                                    data-content="Je ontvangt pushmeldingen wanneer er nieuwe facturen beschikbaar voor je zijn en of je nog openstaande facturen hebt."></i>
                            </div>
                        </div>

                        <div class="form-group mb-3">
                            <div class="form-check form-switch">
                                <input id="disabilityPushNotificationsEnabled" class="form-check-input" name="receive_disability_push_notifications" type="checkbox" role="switch" v-model="disabilityPushNotificationsEnabled" style="transform: scale(1.2);">
                                <label class="form-check-label text-white" for="disabilityPushNotificationsEnabled">
                                    Herinner ziekmelding
                                </label>
                                <i class="ms-2 fa fa-question-circle text-white notifications-explanation" role="button" style="cursor: pointer;"
                                    data-title="Ziekmeldingen"
                                    data-content="Je ontvangt pushmeldingen over lopende ziekmeldingen en wordt op de hoogte gehouden over updates over je ziekmelding."></i>
                            </div>
                        </div>
                    </div>
                </template>

                <hr/>
                
                <div class="d-md-flex d-block position-relative mb-2">
                    <h4 class="fw-bold text-white">2-staps authenticatie</h4>
                    <div class="btn btn-light float-right d-md-block d-none" @click="togglePreference" v-if="twoFactorOptions.length > 0"><i class="fa fa-key me-1"></i> Wijzig voorkeur</div>
                    <div class="btn btn-light d-md-none d-block" @click="togglePreference" v-if="twoFactorOptions.length > 0"><i class="fa fa-key me-1"></i> Wijzig voorkeur</div>
                </div>

                <!-- Instellen welke 2fa methode de voorkeur heeft -->
                <div id="preference" class="mb-3 position-relative">
                    <h5 class="text-white">Voorkeursmethode wijzigen</h5>
                    <div class="d-flex position-relative text-white">
                        <!-- SMS -->
                        <div class="d-block me-2">
                            <div :class="['btn btn-light smooth-opacity text-nowrap', preferred2fa === 'sms' ? '' : 'opacity-50']" @click="() => setPreferredAuthenticationMethod('sms')"><img src="@/assets/icons/phone.png" class="small-info me-1"> SMS</div>
                        </div>

                        <!-- Authenticator -->
                        <div class="d-block me-2">
                            <div :class="['btn btn-light smooth-opacity text-nowrap', preferred2fa === 'authenticator' ? '' : 'opacity-50']" @click="() => setPreferredAuthenticationMethod('authenticator')" v-if="setupAuthenticator"><img src="@/assets/icons/authenticator.png" class="small-info me-1"> Authenticator</div>
                        </div>

                        <!-- Yubikey voorkeur -->
                        <div class="d-block yubikey">
                            <div :class="['btn btn-light smooth-opacity text-nowrap', preferred2fa === 'yubikey' ? '' : 'opacity-50']" @click="() => setPreferredAuthenticationMethod('yubikey')" v-if="setupYubikey"><img src="@/assets/icons/yubikey.png" class="small-info me-1"> Yubikey</div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col">
                            <div class="btn btn-primary" @click="save2faPreference"><i class="fa fa-save me-1"></i> Opslaan</div>
                        </div>
                    </div>
                </div>

                <!-- SMS -->
                <div class="border-ur bg-trans p-2 position-relative">
                    <div class="icon-container-authentication d-flex">
                        <span class="fw-normal small p-1 px-2 mx-1 rounded-1 bg-success text-light">Ingesteld</span>
                        <img src="@/assets/icons/phone.png" class="icon">
                    </div>
                    <div class="d-flex">
                        <h4 class="fw-normal text-white">SMS</h4>
                        <span class="rounded-1 ms-2 bg-info text-dark p-1 d-block h-100 small m-0 preference" v-if="preferred2fa === 'sms'">
                            <span class="d-none d-md-block">Voorkeursmethode</span>
                            <span class="d-block d-md-none"><i class="fa fa-check"></i></span>
                        </span>
                    </div>
                    <p class="text-white">U ontvangt een code op uw mobiele apparaat wanneer u probeert in te loggen op uw account. Hierin staat een code die u moet invoeren tijdens het inlogproces.</p>
                    <p class="text-white fw-bold">
                        <template v-if="phonenumber">
                            De code wordt verstuurd naar <span class="rounded-1 bg-light text-dark p-1 mx-1">{{ phonenumber }}</span>.
                        </template>
                    </p>
                    <div class="mt-2">
                        <router-link class="btn btn-outline-light" to="/personalia">
                            <span class="fw-normal"><i class="fa fa-edit store me-1"></i> Wijzigen</span>
                        </router-link>
                    </div>
                </div>

                <!-- Authenticator -->
                <div class="border-ur bg-trans p-2 position-relative mt-3">
                    <div class="icon-container-authentication d-flex">
                        <span :class="['fw-normal small p-1 px-2 mx-1 rounded-1', setupAuthenticator ? 'bg-success text-light' : 'bg-warning text-dark']">{{ setupAuthenticator ? 'Ingesteld' : 'Niet ingesteld' }}</span>
                        <img src="@/assets/icons/authenticator.png" class="icon">
                    </div>
                    <div class="d-flex">
                        <h4 class="fw-normal text-white">Authenticator</h4>
                        <span class="rounded-1 ms-2 bg-info text-dark p-1 d-block h-100 small m-0 preference" v-if="preferred2fa === 'authenticator'">
                            <span class="d-none d-md-block">Voorkeursmethode</span>
                            <span class="d-block d-md-none"><i class="fa fa-check"></i></span>
                        </span>
                    </div>
                    <p class="text-white">Authenticator is een app voor uw mobiele telefoon. Het genereert getimede codes welke gebruikt worden tijdens het verificatieproces.</p>
                    <p class="text-white fw-bold mb-1">Download de Authenticator app</p>
                    <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank" class="btn btn-light me-1"><i class="fab fa-google-play me-1"></i> Play Store</a>
                    <a href="https://itunes.apple.com/us/app/-authenticator/id388497605?mt=8" target="_blank" class="btn btn-dark"><i class="fab fa-apple store me-1"></i> App Store</a>

                    <p class="text-white fw-bold mb-1 mt-3">Stel 2-staps authenticatie in met de  Authenticator app</p>
                    <div class="mt-2">
                        <router-link :class="['btn', setupAuthenticator ? 'btn-outline-light' : 'btn-primary']" to="/account/setup-authenticator">
                            <span class="fw-normal" v-if="!setupAuthenticator">
                                <i class="fa fa-plus store me-1"></i> Instellen
                            </span>
                            <span class="fw-normal" v-else>
                                <i class="fa fa-edit store me-1"></i> Wijzigen
                            </span>
                        </router-link>
                    </div>
                </div>

                <!-- Yubikey -->
                <div class="border-ur bg-trans p-2 mt-3 position-relative yubikey">
                    <div class="d-flex">
                        <h4 class="fw-normal text-white d-flex">Yubikey</h4>
                        <span class="rounded-1 ms-2 bg-info text-dark p-1 d-block h-100 small m-0 preference" v-if="preferred2fa === 'yubikey'">
                            <span class="d-none d-md-block">Voorkeursmethode</span>
                            <span class="d-block d-md-none"><i class="fa fa-check"></i></span>
                        </span>
                    </div>
                    <div class="icon-container-authentication d-flex">
                        <span :class="['fw-normal small p-1 px-2 mx-1 rounded-1', setupYubikey ? 'bg-success text-light' : 'bg-warning text-dark']">{{ setupYubikey ? 'Ingesteld' : 'Niet ingesteld' }}</span>
                        <img src="@/assets/icons/yubikey.png" class="icon">
                    </div>
                    <p class="text-white">Een Yubikey is een kleine USB-stick die multifactor authenticatie biedt met één druk op de knop. Yubikeys zijn sterk genoeg voor grote ondernemingen en tegelijkertijd simpel genoeg voor iedereen om te gebruiken.</p>

                    <a href="https://www.yubico.com/" target="_blank" class="btn btn-light me-1"><i class="fa fa-wallet me-1"></i> Yubikey aanschaffen</a>

                    <p class="text-white fw-bold mb-1 mt-3">Stel 2-staps authenticatie in met een Yubikey</p>
                    <div class="mt-2">
                        <router-link to="/account/setup-yubikey" :class="['btn', setupYubikey ? 'btn-outline-light' : 'btn-primary']">
                            <span class="fw-normal" v-if="!setupYubikey">
                                <i class="fa fa-plus store me-1"></i> Instellen
                            </span>
                            <span class="fw-normal" v-else>
                                <i class="fa fa-edit store me-1"></i> Wijzigen
                            </span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <Modal v-for="modal in modals" :key="modal.title" :title="modal.title" :content="modal.content"
        :button_text="modal.button_text" :button_icon="modal.button_icon" :url="modal.url" :modal_type="modal.modal_type" :question_enum="modal.question_enum" :additional_class="modal.additional_class"
        @closeModal="closeModal"/>
</template>

<script type="text/javascript">
import $ from 'jquery';
import { Breadcrumb } from '@/App.vue';
import Breadcrumbs from '@/components/BreadcrumbsComponent.vue';
import { setCustomer, isKnab, updateAppearanceKnab } from '@/App.vue';
import { useToast } from 'vue-toastification';
import Modal from '@/components/ModalComponent.vue';

export default {
    name: "account-component",
    components: {
        Breadcrumbs,
        Modal,
    },
    data() {
        return {
            breadcrumbs: [new Breadcrumb('/account', 'Account')],
            currentPassword: "",
            newPassword: "",
            newPasswordRepeat: "",

            newEmailAddress: "",
            newEmailAddressRepeat: "",

            setupAuthenticator: false,
            setupYubikey: false,
            preferred2fa: "",
            twoFactorOptions: [],
            phonenumber: null,

            allPushNotificationsEnabled: false,
            newsPushNotificationsEnabled: false,
            adminPushNotificationsEnabled: false,
            disabilityPushNotificationsEnabled: false,

            customer_id: null,
            modals: [],
            pusher_token: null,
        }
    },
    methods: {
        async submit() {
            await this.$http.post('/password/change/', {
                password: this.currentPassword,
                new_password: this.newPassword,
                new_password_confirmation: this.newPasswordRepeat
            }).then((response) => {
                this.currentPassword = "";
                this.newPassword = "";
                this.newPasswordRepeat = "";
                const toast = useToast();
                toast.success(response.data["alert-success"]);
            }).catch((err) => {
                console.log(err);
            })    
        },
        async submitEmail() {
            await this.$http.post('/email/change', {
                email_address: this.newEmailAddress,
                email_address_repeat: this.newEmailAddressRepeat,
                customer_id: this.customer_id,
            }).then((response) => {
                let data = response.data;
                if(data.status === 200) {
                    const toast = useToast();
                    toast.success(data.comments);
                } else {
                    const toast = useToast();
                    toast.error(data.comments);
                }
            }).catch((err) => {
                console.log(err);
            })    
        },
        setPreferredAuthenticationMethod(method) {
            this.preferred2fa = method;
        },
        async save2faPreference() {
            await this.$http.post('/my', {
                twofactorauthentication_method: this.preferred2fa,
            }).then((response) => {
                setCustomer(response.data)

                const toast = useToast();
                toast.success("Voorkeursmethode voor 2FA is aangepast");
                
                $("#preference").hide(400);
            }).catch((err) => {
                console.log(err);
            });
        },
        togglePreference() {
            $("#preference").toggle(400);
        },
        nothing() {
            return null;
        },
        closeModal() {
            this.modals[0].additional_class = 'disappear';
            setTimeout(() => {
                this.modals = [];
            }, 500);
        },
        async submitPushNotificationSettings() {
            await this.$http.post('/push-notification-settings/change', {
                receive_news_push_notifications: $('input[name="receive_news_push_notifications"]').is(':checked'),
                receive_admin_push_notifications: $('input[name="receive_admin_push_notifications"]').is(':checked'),
                receive_disability_push_notifications: $('input[name="receive_disability_push_notifications"]').is(':checked'),
                pusher_token: this.pusher_token,
                customer_id: this.customer_id,
            }).then((response) => {
                let data = response.data;
                if(data.status === 200) {
                    // Hier is het goed gegaan, maar omdat dit best vaak aangepast kan worden in een korte tijd tonen we verder geen feedback
                } else {
                    const toast = useToast();
                    toast.error(data.comments);
                }
            }).catch((err) => {
                console.log(err);
            })    
        },
    },
    async mounted() {
        if(isKnab()) {
            updateAppearanceKnab();
        }

        let customer;
        let response = await this.$http.get("/my");
        if(response) {
            customer = response.data;
            setCustomer(response.data)
            if(isKnab()) {
                $(".text-white").removeClass("text-white");
                $(".btn-dark, .btn-primary > span, .btn, .btn > span").removeClass("crowdsurance");
                $("a").removeClass("crowdsurance");
                $(".bg-success").removeClass("crowdsurance");
            }
        }

        let context = this;

        $('.notifications-explanation').click(function() {
            const title = $(this).data('title'),
                content = $(this).data('content');
            context.modals.push(context.$createModal(title, content, "fa-check", "Oké!", "", context.$ModalType.OK, "nothing"));
        });

        const allButtons = $('#newsPushNotificationsEnabled, #adminPushNotificationsEnabled, #disabilityPushNotificationsEnabled');

        // Controleer het gedrag van de 'allPushNotificationsEnabled' knop
        $('#allPushNotificationsEnabled').on('change', function() {
            // $(this).is(':checked')
            allButtons.prop('checked', $(this).is(':checked'));
        });

        allButtons.on('change', function() {
            // Check all buttons
            let checkedCount = 0,
                max = allButtons.length;

            allButtons.each(function() {
                if($(this).is(':checked'))
                    checkedCount++;
            });
            
            if(checkedCount < max) {
                $('#allPushNotificationsEnabled').prop('checked', false);
            } else {
                $('#allPushNotificationsEnabled').prop('checked', true);
            }
        });  

        if(customer) {
            this.setupAuthenticator = customer.authenticator_is_set_up;
            this.setupYubikey = customer.yubikey_is_set_up;
            this.preferred2fa = customer.twofactorauthentication_method;

            if(customer.phone_mobile)
                this.phonenumber = customer.phone_mobile;
            else if(customer.phone)
                this.phonenumber = customer.phone;
            else if(customer.business_phone_mobile)
                this.phonenumber = customer.business_phone_mobile;
            else if(customer.business_phone)
                this.phonenumber = customer.business_phone;

            this.customer_id = customer.id;
            this.pusher_token = customer.pusher_token;

            if(this.pusher_token) {
                let $pushNotificationsTemplate = $('#pushNotificationsTemplate');
                $pushNotificationsTemplate.show();
            }

            if(this.setupAuthenticator)
                this.twoFactorOptions.push({title: 'Authenticator', value: 'authenticator'});
            if(this.setupYubikey)
                this.twoFactorOptions.push({title: 'Yubikey', value: 'yubikey'});

            $(`#preference2fa option[value=${this.preferred2fa}]`).attr('selected', 'selected');
            $("#currentEmail").text(customer.email);

            if(customer.receive_news_push_notifications === 1) {
                $('input[name="receive_news_push_notifications"]').prop('checked', true);
            }

            if(customer.receive_admin_push_notifications === 1) {
                $('input[name="receive_admin_push_notifications"]').prop('checked', true);
            }

            if(customer.receive_disability_push_notifications === 1) {
                $('input[name="receive_disability_push_notifications"]').prop('checked', true)
                    .trigger('change');
            }

            // Verstuur pushmelding instelling op naar de API
            $('#pushNotifications input.form-check-input').change(function() {
                context.submitPushNotificationSettings();
            });
        }

        // Laat alle objecten zachtjes infaden
        $(".fade-all").fadeOut(0);
        $(".fade-all").fadeIn('slow');

        $("#preference").hide();

        if(this.$isWebView()) {
            $(".yubikey").addClass("d-none");
        }
    }
}
</script>

<style scoped>
hr {
    border-color: rgba(255, 255, 255, 0.2);
}

.preference {
    transform: translateY(1px);
}

.small-info {
    width: 1.3rem;
    transform: translateY(-2px);
}

.smooth-opacity {
    transition: opacity var(--transition-400ms) ease;
}

.icon {
    width: 40px;
    height: 40px;
    opacity: 1;
    position: relative;
}

.check-icon {
    width: 32px;
    height: 32px;
    opacity: 1;
    filter: invert();
    position: relative;
    transform: translateY(4px);

}

.large {
    color: #fff;
    font-size: 36px;
}

.icon-container-authentication {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 16;
    display: flex;
}

.border-ur bg-trans {
    border: 1px solid rgba(255, 255, 255, 0.25);
}

input.form-check-input {
    border: 1px solid #fff6;
}
</style>